<script setup lang="ts"></script>

<template>
  <div style="border-top-color: transparent" class="border-2 border-app-gray-500 border-solid rounded-full animate-spin"></div>
</template>
